export default {
  sizes: {
    xs: {
      fontSize: '0.6em',
    },
    sm: {
      fontSize: '0.7em',
    },
    md: {
      fontSize: '0.8em',
      textTransform: 'none',
    },
    lg: {
      fontSize: '0.9em',
      textTransform: 'none',
    },
  },
  defaultProps: {
    size: 'md',
  },
};
